<core-card [actions]="['expand']" *ngIf="ticket !== null">
    <h4 class="card-title">{{ticket.id}} - {{ticket.title}}</h4>
    <div class="card-body" style="max-height: 569px;  overflow-y: scroll;">
        <div class="col-md-12">
            <div class="table-responsive">
                <table id="ticketData" class="table table-sm table-hover">
                    <tr>
                        <th class="text-center" colspan="1">{{'Project' | translate}}</th>
                        <td class="text-center" colspan="1" *ngIf="ticket.projectId !== 0 || token === 'token'">
                            {{ticket.projectName}}<P *ngIf="ticket.status==true">(BİTTİ)</P><P *ngIf="ticket.status==false">(BİTMEDİ)</P>
                        </td>
                        <td id="projectTd" class="text-center" colspan="1"
                            *ngIf="ticket.projectId === 0 && token === 'dashboardToken'">
                            <ng-select [virtualScroll]="true" id="projectId" name="projectId" class="ng-select-size-sm"
                                [items]="projects" [(ngModel)]="projectId" bindLabel="name" bindValue="id">
                            </ng-select>
                            <button type="button" (click)="onChangeProject()" class="projectBtn"
                                tooltipClass="fadeInAnimation" placement="top"
                                ngbTooltip="{{'SetProject' | translate}}">
                                <i class="fa fa-check"></i>
                            </button>
                        </td>
                        <th class="text-center" colspan="1">{{'Priority' | translate}}</th>
                        <td class="text-center" colspan="1">{{priority[ticket.priority] | translate}}</td>
                    </tr>
                    <tr>
                        <th class="text-center" colspan="1">{{'Status' | translate}}</th>
                        <td class="text-center" colspan="1">{{ticketStatus[ticket.ticketStatus] | translate}}
                        </td>
                        <th class="text-center" colspan="1">{{'CreationDateTime' | translate}}</th>
                        <td class="text-center" colspan="1">
                            {{ticket.creationDateTime | dateConverter:'DD/MM/yyyy HH:mm:ss'}}</td>
                    </tr>
                    <tr>
                        <th class="text-center" colspan="1">{{'CustomerName' | translate}}</th>
                        <td class="text-center" colspan="1">{{ticket.customerName}}</td>
                        <th class="text-center" colspan="1">{{'CreatorUserFullName' | translate}}</th>
                        <td class="text-center" colspan="1">{{ticket.creatorUserFullName}}</td>
                    </tr>
                    <tr *ngIf="token === 'dashboardToken'">
                        <th class="text-center" colspan="1">{{'TicketType' | translate}}</th>
                        <td class="text-center" colspan="1">
                            <select class="form-control form-control-sm" id="ticketType" name="ticketType"
                                [(ngModel)]="ticket.ticketTypeId" (change)="changeTicketTypes()">
                                <option [ngValue]="null">{{'PleaseSelectAnyItem' | translate}}
                                </option>
                                <option *ngFor="let ticketType of ticketTypeResultList.data" [ngValue]="ticketType.id">
                                    {{ticketType.name}}
                                </option>
                            </select>
                        </td>
                        <th class="text-center" colspan="1"></th>
                        <td class="text-center" colspan="1"></td>
                    </tr>
                </table>
            </div>
        </div>
        <div class="row">
            <div class="col-md-3" *ngIf="ticket.projectId !== 0">
                <app-assign [assignedEmployeeId]="ticket.assignedEmployeeId" [token]="token"
                    [assignedEmployeeFullName]="ticket.assignedEmployeeFullName"
                    [assignedEmployeePersonalPictureFileName]="ticket.assignedEmployeePersonalPictureFileName"
                    [employeeDropdown]="employeeDropdown" (employeeAssigned)="assigned($event)"></app-assign>
            </div>
            <div class="col-md-2" *ngIf="ticket.assignedEmployeeId !== null && token === 'dashboardToken'">
                <div class="form-group">
                    <label class="form-label" for="ticketStatus">{{'Status' | translate}}</label>
                    <select class="form-control form-control-sm" id="ticketStatus" name="ticketStatus"
                        [(ngModel)]="ticketStatusVariable" (change)="changeTicketStatus()" [disabled]="assignedTo != 71 && ticketStatusVariable == 4">
                        <option [ngValue]="null">{{'PleaseSelectAnyItem' | translate}}
                        </option>
                        <option *ngFor="let enumItem of ticketStatus | enumKey" [ngValue]="enumItem.key">
                            {{enumItem.value | translate}}
                        </option>
                    </select>
                </div>
            </div>
            <div class="col-md-2" *ngIf="token === 'dashboardToken'">
                <div class="form-group">
                    <label class="form-label" for="ticketStatus">{{'Level' | translate}}</label>
                    <select class="form-control form-control-sm" id="ticketLevel" name="ticketLevel"
                        [(ngModel)]="ticketLevelVariable" (change)="changeTicketLevel()">
                        <option [ngValue]="null">{{'PleaseSelectAnyItem' | translate}}
                        </option>
                        <option *ngFor="let enumItem of ticketLevel | enumKey" [ngValue]="enumItem.key">
                            {{enumItem.value | translate}}
                        </option>
                    </select>
                </div>
            </div>
            <div class="col-md-1" *ngIf="token === 'dashboardToken'">
                <div class="form-group">
                    <label class="form-label" for="ticketStatus">{{'StoryPoint' | translate}}</label>
                    <select class="form-control form-control-sm" id="ticketStoryPoint" name="ticketStoryPoint"
                        [(ngModel)]="ticketStoryPoint" (change)="updateStoryPoint()">
                        <option [ngValue]="null">{{'PleaseSelectAnyItem' | translate}}
                        </option>
                        <option [ngValue]="1">1</option>
                        <option [ngValue]="3">3</option>
                        <option [ngValue]="5">5</option>
                        <option [ngValue]="8">8</option>
                        <option [ngValue]="13">13</option>
                    </select>
                </div>
            </div>
            <div class="col-md-4 row mx-auto justify-content-center align-items-center"
                *ngIf="token === 'dashboardToken'">
                <button class="btn btn-sm btn-outline-dark mr-50"
                    (click)="showSubtaskDetail(subtaskDetailModal)">{{'SubTaskDetail' | translate}}</button>
                <button class="btn btn-sm btn-outline-warning mr-50"
                    (click)="onShowCustomerEmployeeInformation(employeeCOntactModal)">{{'CustomerEmployee' |
                    translate}}</button>
                <button class="btn btn-sm btn-outline-dark mr-50"
                    (click)="showAddSubTicket(addSubTicketModal)">{{'AddSubTicket' | translate}}</button>
            </div>
        </div>
        <!-- media-list -->
        <!-- <div class="media-list media-bordered">
            <div class="media" *ngFor="let item of ticketComments">
                <picture class="media-left align-self-center">
                    <img attr.src="{{utility.serviceAddress}}images/employee/{{item.personalPictureFileName}}"
                        alt="{{item.userFullName}}" height="64" width="64" />
                </picture>
                <div class="media-body">
                    <h5 class="media-heading">{{item.userFullName}}</h5>
                    <small>({{item.dateTime | dateConverter:'DD/MM/yyyy HH:mm:ss'}})</small>
                    <pre class="mb-0">{{item.comment}}</pre>

                </div>
            </div>
        </div> -->
        <!-- media-list -->

        <!-- timeline -->
        <div id="timelineDiv" class="col-md-12">
            <ul class="timeline">
                <li class="timeline-item" *ngFor="let item of ticketComments">
                    <span class="timeline-point">
                        <img *ngIf="item.personalPictureFileName !== '' && userMode.Employee === item.userMode"
                            attr.src="{{utility.serviceAddress}}images/employee/{{item.personalPictureFileName}}"
                            alt="{{item.userFullName}}" />
                        <img *ngIf="item.personalPictureFileName !== '' && userMode.CustomerEmployee === item.userMode"
                            attr.src="{{utility.serviceAddress}}images/customer-employee/{{item.personalPictureFileName}}"
                            alt="{{item.userFullName}}" />
                        <img *ngIf="item.personalPictureFileName === ''" src="assets/images/avatar.png"
                            alt="{{item.userFullName}}" />
                    </span>
                    <div class="timeline-event">
                        <div class="d-flex justify-content-between flex-sm-row flex-column mb-sm-0 mb-1">
                            <h6>{{item.userFullName}}</h6>
                            <ng-container *ngIf="token === 'dashboardToken' && item.isPublic === true">
                                <span class="isPublicSpan">({{'IsPublic' | translate}})</span>
                            </ng-container>
                            <span class="timeline-event-time">
                                {{item.dateTime | dateConverter:'DD/MM/yyyy HH:mm:ss'}}
                            </span>
                        </div>
                        <!-- <pre class="mb-0" [ngClass]="{'private' : (item.isPublic === false)}">{{item.comment}}</pre> -->
                        <pre class="mb-0">{{item.comment}}</pre>
                        <button *ngIf="item.userId == assignedTo" [disabled]="isBusy == true" type="button"
                            tooltipClass="fadeInAnimation" placement="top" ngbTooltip="{{'TicketEdit' | translate}}"
                            (click)="commentEdit(commentModal,item.id,item.comment)"><i
                                data-feather="edit-2"></i></button>
                        <section>
                            <ng-container *ngFor="let documentItem of item.documents">
                                <a target="_blank"
                                    attr.href="{{utility.serviceAddress}}document/{{documentItem.documentFileName}}"><i
                                        class="fa fa-download"></i></a>
                            </ng-container>
                        </section>
                    </div>
                </li>
            </ul>
        </div>
        <!-- timeline -->
        <div class="col-md-12" *ngIf="token === 'dashboardToken'">
            <div class="form-group">
                <label for="carbonCopyList">{{'CarbonCopy' | translate}} </label>
                <ng-select [virtualScroll]="true" id="carbonCopyList" name="carbonCopyList" [items]="emails"
                    [(ngModel)]="carbonCopies" bindLabel="fullNameAndEmail" [clearSearchOnAdd]="true" [multiple]="true"
                    [closeOnSelect]="false" [hideSelected]="true"
                    [ngClass]="{'is-invalid' : (carbonCopyIsInvalid == true)}">
                </ng-select>
            </div>
        </div>
        <!-- <div class="col-md-12">
            <div class="form-group">
                <label for="blindCarbonCopyList">{{'BlindCarbonCopy' | translate}} </label>
                <ng-select [virtualScroll]="true" id="blindCarbonCopyList" name="blindCarbonCopyList" [items]="emails"
                    [(ngModel)]="blindCarbonCopies" bindLabel="fullNameAndEmail" [clearSearchOnAdd]="true"
                    [multiple]="true" [closeOnSelect]="false" [hideSelected]="true" [addTag]="addNewCarbonCopy">
                </ng-select>
            </div>
        </div> -->
        <!-- Add Comment -->
        <div class="col-md-12">
            <div class="form-group">
                <label class="form-label" for="comment">{{'Comment' | translate}}</label>
                <input type="file" id="selectedFile" #file1 (change)="upload(file1.files)" />
                <button id="fileUploadButton" [disabled]="isBusy == true" type="button" tooltipClass="fadeInAnimation"
                    placement="top" ngbTooltip="{{'Attach' | translate}}" (click)="openFileUploader()"><i
                        class="fa fa-paperclip"></i></button>
                <textarea class="form-control form-control-sm" rows="5"
                    [ngClass]="{'is-invalid' : (commentIsInvalid == true)}" [(ngModel)]="addTicketCommentInput.comment"
                    name="comment" id="comment"></textarea>
            </div>
        </div>
        <div class="table-responsive" *ngIf="addTicketCommentInput.ticketDocuments.length > 0">
            <table class="table table-sm table-hover">
                <thead>
                    <tr>
                        <th class="text-center">{{'Name' | translate}}</th>
                        <th class="text-center">{{'Actions' | translate}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of addTicketCommentInput.ticketDocuments">
                        <td class="text-center">{{item.documentFileName}}</td>
                        <td class="text-center">
                            <button [disabled]="isBusy == true" type="button" tooltipClass="fadeInAnimation"
                                placement="top" ngbTooltip="{{'Delete' | translate}}"
                                (click)="displayDeleteModal(modalDanger, item)"><i class="fa fa-trash"></i></button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="row">
            <div class="col-md-2" *ngIf="token === 'dashboardToken'">
                <div class="demo-inline-spacing">
                    <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" id="customSwitch10" name="customSwitch10"
                            [(ngModel)]="addTicketCommentInput.isPublic" />
                        <label class="custom-control-label" for="customSwitch10">{{'IsPublic' |
                            translate}}?
                        </label>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <button type="submit" rippleeffect="" [disabled]="isBusy == true"
                    class="btn btn-success btn-sm mr-1 waves-effect waves-float waves-light" (click)="submit()">{{'Add'
                    | translate}}</button>
            </div>
        </div>
        <!-- Add Comment -->
    </div>
</core-card>
<ng-template #subtaskDetailModal let-modal>
    <div class="modal-body" tabindex="0" ngbAutofocus>
        <app-sub-task-detail [ticketTaskResult]="ticketTaskResult" [employeeDropdown]="employeeDropdown">
        </app-sub-task-detail>
    </div>
</ng-template>
<ng-template #addSubTicketModal let-modal>
    <div class="modal-body" tabindex="0" ngbAutofocus>
        <app-sub-ticket-detail [ticketHeaderId]="ticket == null ? 0 : ticket.id">
        </app-sub-ticket-detail>
    </div>
</ng-template>
<ng-template #employeeCOntactModal let-modal>
    <div class="modal-body" tabindex="0" ngbAutofocus>
        <div class="table-responsive">
            <ng-container *ngFor="let item of customerEmployeeFullList">
                <div class="divider divider-primary">
                    <div class="divider-text">
                        <img class="rounded-circle mr-50" *ngIf="item.personalPictureFileName !== ''"
                            src="{{utility.serviceAddress}}images/customer-employee/{{item.personalPictureFileName}}"
                            height="50" width="50" [alt]="item.fullName" />
                        <img class="rounded-circle mr-50" *ngIf="item.personalPictureFileName === ''"
                            src="assets/images/avatar.png" height="50" width="50" [alt]="item.fullName" />
                        {{item.fullName}}
                    </div>
                </div>
                <table class="table table-sm table-hover">
                    <tr>
                        <th colspan="1">{{'BusinessRole' | translate}}</th>
                        <td colspan="1">{{item.businessRoleName}}</td>
                        <th colspan="1">{{'Email' | translate}}</th>
                        <td colspan="1">{{item.email}}</td>
                    </tr>
                </table>
                <table class="table table-sm table-hover">
                    <thead>
                        <tr>
                            <th class="text-center">{{'ContactType' | translate}} </th>
                            <th class="text-center">{{'Contact' | translate}}</th>
                            <th class="text-center">{{'IsDefault' | translate}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item2 of item.customerEmployeeContacts">
                            <td class="text-center">{{item2.contactTypeName}}</td>
                            <td class="text-center">{{item2.contact}}</td>
                            <td class="text-center"><i class="feather"
                                    [ngClass]="{'icon-check' : (item2.isDefault == true), 'icon-x' : (item2.isDefault == false)}"></i>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </ng-container>
        </div>
    </div>
</ng-template>
<ng-template #commentModal let-modal>
    <div class="modal-body" tabindex="0" ngbAutofocus>
        <div class="table-responsive">
            <div class="form-group">
                <label class="form-label" for="comment">{{'Comment' | translate}}</label>
                <textarea class="form-control form-control-sm" rows="5"
                    [ngClass]="{'is-invalid' : (commentIsInvalid == true)}" [(ngModel)]="newComment" name="comment"
                    id="comment"></textarea>
                <button class="btn btn-sm btn-outline-success mt-2"
                    (click)="updateComment(newComment)">{{'UpdateComment' |
                    translate}}</button>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #modalDanger let-modal>
    <div class="modal-header">
        <h5 class="modal-title" id="exampleModalCenterTitle">{{'Alert' | translate}}</h5>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" tabindex="0" ngbAutofocus>
        {{utility.AlertModalDeleteMessage | translate}}
    </div>
    <div class="modal-footer">
        <button type="submit" rippleeffect="" [disabled]="isBusy == true"
            class="btn btn-danger mr-1 waves-effect waves-float waves-light" (click)="delete()">{{'Delete' |
            translate}}</button>
    </div>
</ng-template>
<app-alert [result]="result"></app-alert>